import React from 'react';

export interface IOpenModalContext {
  isLoading: boolean;
  show: () => unknown;
}

export const OpenModalContext = React.createContext<IOpenModalContext>(
  {} as IOpenModalContext,
);
